module.exports = __webpack_public_path__ + "static/media/tie-rods-red.582983c7.svg";